import { apiClient } from "../services/apiClient";
import { ATP_API_URL } from "../config/apiConfig";

/**
 * Step 1 — Send OTP to logged-in user's email before download.
 * POST /api/Onboarding/send-download-otp
 */
export const sendDownloadOtpAction = async (email) => {
  try {
    const response = await apiClient.post(ATP_API_URL.SEND_DOWNLOAD_OTP, {
      email,
    });
    if (response?.status === 200) {
      return {
        success: response.data?.success !== false,
        message: response.data?.message || "OTP sent successfully",
      };
    }
    return { success: false, message: "Failed to send OTP" };
  } catch (error) {
    return {
      success: false,
      message:
        error?.response?.data?.message || error.message || "Failed to send OTP",
    };
  }
};

/**
 * Step 2 — Verify OTP entered by user.
 * POST /api/Onboarding/verify-download-otp
 */
export const verifyDownloadOtpAction = async (email, otp) => {
  try {
    const response = await apiClient.post(ATP_API_URL.VERIFY_DOWNLOAD_OTP, {
      email,
      otp,
    });
    if (response?.status === 200) {
      return {
        success: response.data?.success !== false,
        message: response.data?.message || "OTP verified",
      };
    }
    return { success: false, message: "OTP verification failed" };
  } catch (error) {
    return {
      success: false,
      message:
        error?.response?.data?.message ||
        error.message ||
        "OTP verification failed",
    };
  }
};

/**
 * Step 2b — Resend OTP (same payload as send).
 * POST /api/Onboarding/resend-download-otp
 */
export const resendDownloadOtpAction = async (email) => {
  try {
    const response = await apiClient.post(ATP_API_URL.RESEND_DOWNLOAD_OTP, {
      email,
    });
    if (response?.status === 200) {
      return {
        success: response.data?.success !== false,
        message: response.data?.message || "OTP resent successfully",
      };
    }
    return { success: false, message: "Failed to resend OTP" };
  } catch (error) {
    return {
      success: false,
      message:
        error?.response?.data?.message ||
        error.message ||
        "Failed to resend OTP",
    };
  }
};

/**
 * Step 3 — Download entity excel after OTP is verified.
 * GET /api/Onboarding/download-entity-excel  → blob (xlsx)
 */
export const downloadEntityExcelAction = async () => {
  try {
    const response = await apiClient.get(ATP_API_URL.DOWNLOAD_ENTITY_EXCEL, {
      responseType: "blob",
    });
    if (response?.status === 200 && response.data) {
      const contentDisposition =
        response.headers?.["content-disposition"] || "";
      const filenameMatch = contentDisposition.match(
        /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
      );
      const filename = filenameMatch
        ? filenameMatch[1].replace(/['"]/g, "")
        : `entities_${new Date().toISOString().slice(0, 10)}.xlsx`;

      const url = URL.createObjectURL(new Blob([response.data]));
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
      return { success: true, message: "Download started" };
    }
    return { success: false, message: "Download failed" };
  } catch (error) {
    return {
      success: false,
      message:
        error?.response?.data?.message || error.message || "Download failed",
    };
  }
};
